import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Feature list',
  name: 'featureList',
  type: 'object',
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      type: 'string',
    }),
    defineField({
      title: 'Features',
      name: 'features',
      type: 'array',
      of: [{ type: 'feature' }],
      validation: (rule) => rule.min(4).max(4),
    }),
  ],
  preview: {
    select: {
      title: 'title',
      features: 'features',
    },
    prepare({ title, features }) {
      const featureCount = features?.length || 0
      return {
        title: title || 'Untitled',
        subtitle: `Feature list (${featureCount} features)`,
      }
    },
  },
})
